/* ─── Root ─── */

.root {
  display: grid;
  gap: var(--section-gap);
}

@media (--window-expanded) {
  .root {
    grid-template-columns: var(--aside-width, 320px) 1fr;
  }

  .end {
    grid-template-columns: 1fr var(--aside-width, 320px);
  }

  .end > .aside {
    order: 2;
  }
}

/* ─── Aside widths ─── */

.asideSm {
  --aside-width: 240px;
}

.asideMd {
  --aside-width: 320px;
}

.asideLg {
  --aside-width: 400px;
}

/* ─── Aside ─── */

.aside {
}

.sticky {
  position: sticky;
  top: 0;
  align-self: start;
}

/* ─── Main ─── */

.main {
  min-width: 0; /* prevent grid blowout */
}
